import type { Expense } from '../services/expenses'

/**
 * Gelir-gider hesabı (2 Kas 2026). Ay "2026-11" biçiminde.
 * Gelir: abonelik ödemeleri, ödeme tarihinin ayına. Gider: tek seferlik
 * kendi ayına; aylık, başladığı aydan bittiği aya kadar (o ay hariç) her ay.
 */
export interface MonthTotals {
  month: string
  incomeKurus: number
  expenseKurus: number
}

const ym = (day: string) => day.slice(0, 7)

function nextMonth(m: string): string {
  const [y, mo] = m.split('-').map(Number)
  return mo === 12 ? `${y + 1}-01` : `${y}-${String(mo + 1).padStart(2, '0')}`
}

/** Aylık gider bu ay sayılıyor mu. */
export function activeIn(e: Expense, month: string): boolean {
  if (e.kind === 'once') return ym(e.spentOn) === month
  return ym(e.spentOn) <= month && (!e.endsOn || month < ym(e.endsOn))
}

/**
 * İlk kayıttan bu aya kadar her ay (yeniden eskiye). Kayıt yoksa yalnız bu ay.
 */
export function monthlyTotals(
  payments: { paidOn: string; amountKurus: number }[],
  expenses: Expense[],
  thisMonth: string,
): MonthTotals[] {
  const starts = [...payments.map((p) => ym(p.paidOn)), ...expenses.map((e) => ym(e.spentOn))].filter(
    (m) => m <= thisMonth,
  )
  let m = starts.length ? starts.reduce((a, b) => (a < b ? a : b)) : thisMonth
  const out: MonthTotals[] = []
  while (m <= thisMonth) {
    const month = m
    out.push({
      month,
      incomeKurus: payments.filter((p) => ym(p.paidOn) === month).reduce((s, p) => s + p.amountKurus, 0),
      expenseKurus: expenses.filter((e) => activeIn(e, month)).reduce((s, e) => s + e.amountKurus, 0),
    })
    m = nextMonth(m)
  }
  return out.reverse()
}

export const monthLabel = (month: string) =>
  new Date(`${month}-15T12:00:00`).toLocaleDateString('tr-TR', { month: 'long', year: 'numeric' })
